import axios, { Canceler } from 'axios';
import { getUrlRackTypeApi } from '../utils/util';
import ApiHandler from './ApiHandler';

const cancelToken = axios.CancelToken;
let cancel: Canceler;

export const baseURL = String(getUrlRackTypeApi(window));

export default class RackTypeTypeApi {

    static async search(text: string) {
        if (cancel !== undefined){
            cancel('cancelled-by-request');
        }
        var parameters = `CodeStart=${text}&rowsPerPage=15`;

        var response = await ApiHandler(baseURL).get(`rackType/Search?${parameters}`, {
            cancelToken: new cancelToken(c => {
                cancel = c;
            })
        });
        return response.data;
    }
}
